export interface SettingGroup {
  name: string;
  settings: Setting[];
}

export interface Setting {
  name: string;
  default: any;
  type: SettingType;
  options?: any[];
  range?: [number, number];
  /**
   * Ustawienie, którego nikt już nie czyta. Definicja zostaje, bo wpisy w grupach użytkowników trzyma
   * serwer, a bez niej zarządzanie pokazałoby wiersz bez nazwy i bez zakresu wartości.
   */
  deprecated?: boolean;
}

export enum SettingType {
  BOOLEAN,
  INTEGER,
  FLOAT,
  TEXT,
  ROLE,
  SINGLE_OPTION,
  MULTIPLE_OPTIONS,
  IMAGE
}
